import { callCommand } from '@/services/dockCommandService'
import { startLivestream } from '@/services/DockService'

export async function refreshLivestream(dockSn, videoId, channelName) {
  try {
    await stopLivestream(dockSn, videoId)
  } catch (error) {
    console.error(error)
  }

  await startLivestream(dockSn, { channelName, videoId })
}

export function stopLivestream(dockSn, videoId) {
  return callCommand(dockSn, 'live_stop_push', {
    video_id: videoId
  })
}
